export default __webpack_public_path__ + "images/134ab7d2f304029f6f378667b9c8777e-atlanta_mobile.webp";